import React, {useEffect, useRef, useState} from "react";
import {
    DatePicker,
    InputBox,
    Modal, notification,
    Popconfirm,
    Table,
    Tooltip,
} from "../../components/Elements/appUtils";
import {fetchSale, fetchSaleForCsv, fetchSaleProductsForCsv} from "./actions";
import PageHeader from "../../components/Elements/pageHeader";

import moment from "moment";
import {getToken} from "../../request";
import {cancelSaleUrl, getProductReport, statusChangeUrl} from "../purchase/api";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {hideLoader, showLoader} from "../../actions/loader";
import {getItemLocalstorage} from "../../components/_utils/_utils";
import {DefaultTablePagination} from "../../components/Elements/appUtils";
import SearchCustomer from "../customer/chooseCustomer/searchCustomer";
import {fetchSaleCategory} from "../category/actions";
import {getStateByCountry, shipthrough} from "../../components/_utils/appUtils";
import {SelectRc} from "../../components/Elements/Select";
import PaymentInDrawer from "./drawers/paymentInDrawer";

const ProductReportList = (props) => {
    let {customerDetails, Report, visible, onClose, paymentRecord, status} = props;
    let showStatus = status == 'Canceled' ? '(Cancelled Sale)' : ''
    return (
        <>
            <Modal
                title={
                    <>
                        Product List{" "}
                        {showStatus && (
                            <span style={{backgroundColor: '#e7baba', padding: '2px 4px'}}>
                                {showStatus}
                            </span>
                        )}
                    </>
                }

                width={"95%"}
                visible={visible}
                onClose={onClose}
            >
                <div className={"mb50 bordered"}>
                    {customerDetails ? (
                        <div className="d-inline-block border border-2">
                            <div className="item-flex">
                                <h5 className="m-3 d-block">
                                    Name:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.customerName}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    State:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.customerState}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    Invoice No:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.customerInvoice}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    Number:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.customerNumber}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    Date:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {moment(customerDetails.salesDate).format("DD-MMM-YYYY")}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    Tracking Details:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.trackingDetails}
                                    </span>
                                </h5>
                                <h5 className="m-3 d-block">
                                    Ship Through:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.shipThrough}
                                    </span>
                                </h5>
                            </div>
                            <div>
                                <h5 className="m-3 d-block">
                                    Address:{" "}
                                    <span className="font-weight-normal ms-2">
                                        {customerDetails.address}
                                        {`${customerDetails.city ? ` ${customerDetails.city}` : ''}`}
                                        {`${customerDetails.state ? `, ${customerDetails.state}` : ''}`}
                                        {`${customerDetails.country ? `, ${customerDetails.country}` : ''}`}
                                    </span>
                                </h5>
                            </div>
                        </div>
                    ) : null}
                    {Report && Report.length ? (
                        <div
                            className="table-wrapper mt-4"
                            style={{
                                maxHeight: "200px",
                                overflowX: "auto",
                                overflowY: "auto",
                            }}
                        >
                            <table className="table table-bordered mt-4">
                                <thead>
                                <tr>
                                    <td>Sr no.</td>
                                    <td>Product Name</td>
                                    <td>Report Type</td>
                                    <td>Mfg Date</td>
                                    <td>Exp Date</td>
                                    <td>Batch</td>
                                    <td>Qty.</td>

                                    <td>Sale Price</td>
                                    <td>Price</td>
                                    <td>Dis Amt.</td>
                                    <td>Taxable Amt.</td>
                                    {customerDetails.cgstAmount !== 0 &&
                                    customerDetails.sgstAmount !== 0 ? (
                                        <>
                                            <td>CGST Amt.</td>
                                            <td>SGST Amt.</td>
                                        </>
                                    ) : customerDetails.igstAmount !== 0 ? (
                                        <td>IGST Amt.</td>
                                    ) : (
                                        <>
                                            <td>CGST Amt.</td>
                                            <td>SGST Amt.</td>
                                        </>
                                    )}
                                    <td>Net Amt.</td>
                                </tr>
                                </thead>
                                <tbody>
                                {Report &&
                                    Report.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.productName}</td>
                                            <td>{item.reportType}</td>
                                            <td>{item.manufacturingDate}</td>
                                            <td>{item.expiryDate}</td>
                                            <td>{item.batchNo}</td>
                                            <td>{item.quantity}</td>
                                            <td>Rs. {item.salePrice}</td>
                                            <td>Rs. {item.price}</td>

                                            <td>
                                                Rs. {item.discountAmount} ({item.discount}%)
                                            </td>
                                            <td>Rs. {item.taxableAmount}</td>
                                            {customerDetails.igstAmount === 0 ? (
                                                <>
                                                    <td>
                                                        Rs. {item.cgstAmount} ({item.gst / 2}%)
                                                    </td>
                                                    <td>
                                                        Rs. {item.sgstAmount} ({item.gst / 2}%)
                                                    </td>
                                                </>
                                            ) : customerDetails.cgstAmount === 0 &&
                                            customerDetails.sgstAmount === 0 ? (
                                                <td>
                                                    Rs. {item.igstAmount} ({item.gst}%)
                                                </td>
                                            ) : (
                                                <>
                                                    <td>
                                                        Rs. {item.cgstAmount} ({item.gst / 2}%)
                                                    </td>
                                                    <td>
                                                        Rs. {item.sgstAmount} ({item.gst / 2}%)
                                                    </td>
                                                </>
                                            )}

                                            <td>Rs. {item.netAmount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : null}
                </div>

                <div className="Total-section mt-4">
                    <div className="row">
                        <div className="col-sm-7 mt-1">
                            <h6 style={{fontSize: "13px"}}>Payment Details:</h6>
                            <div
                                style={{
                                    borderBottom: "1px solid #000",
                                    marginTop: "10px",
                                    width: "300px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <span style={{fontSize: "13px"}}>PAYMODE</span>
                                <span style={{fontSize: "13px"}}>AMOUNT</span>
                            </div>

                            <div>
                                {paymentRecord.map((val, innerIndex) => (
                                    <div
                                        key={innerIndex}
                                        style={{
                                            marginTop: "10px",
                                            width: "300px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span style={{fontSize: "13px"}}>{val.paymentType}</span>
                                        <span style={{fontSize: "13px"}}>{val.amount}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-sm-5 border-design">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-7">
                                            <div style={{textAlign: "right"}}>
                                                <p style={{fontSize: "13px"}}>
                                                    <b>Taxable Amt :</b>
                                                </p>
                                                {customerDetails.cgstAmount !== 0 &&
                                                customerDetails.sgstAmount !== 0 ? (
                                                    <>
                                                        <p style={{fontSize: "13px"}}>
                                                            <b>CGST Total :</b>{" "}
                                                        </p>
                                                        <p style={{fontSize: "13px"}}>
                                                            <b>SGST Total :</b>{" "}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <p style={{fontSize: "13px"}}>
                                                        <b>IGST Total : </b>
                                                    </p>
                                                )}

                                                <p style={{fontSize: "13px"}}>
                                                    <b>Rounded Off :</b>
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    <b>Total Amt :</b>
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    <b>Cash Discount :</b>
                                                </p>

                                                <div
                                                    style={{
                                                        borderBottom: "1px solid #000",
                                                        marginTop: "7px",
                                                        width: "185%",
                                                        marginLeft: "10px",
                                                        textAlign: "right",
                                                    }}
                                                />
                                                <p style={{fontSize: "13px"}}>
                                                    <b> Net Amt :</b>
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    <b>Paid Amt :</b>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div style={{textAlign: "right"}}>
                                                <p style={{fontSize: "13px"}}>
                                                    {" "}
                                                    ₹{" "}
                                                    {parseFloat(customerDetails.taxableAmount).toFixed(2)}
                                                </p>
                                                {customerDetails.cgstAmount !== 0 &&
                                                customerDetails.sgstAmount !== 0 ? (
                                                    <>
                                                        <p style={{fontSize: "13px"}}>
                                                            {" "}
                                                            ₹{" "}
                                                            {parseFloat(customerDetails.cgstAmount).toFixed(
                                                                2
                                                            )}
                                                        </p>
                                                        <p style={{fontSize: "13px"}}>
                                                            {" "}
                                                            ₹{" "}
                                                            {parseFloat(customerDetails.sgstAmount).toFixed(
                                                                2
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <p style={{fontSize: "13px"}}>
                                                        {" "}
                                                        ₹{" "}
                                                        {parseFloat(customerDetails.igstAmount).toFixed(2)}
                                                    </p>
                                                )}

                                                <p style={{fontSize: "13px"}}>
                                                    ₹{" "}
                                                    {parseFloat(customerDetails.cutOffAmount && customerDetails.cutOffAmount != null ?
                                                        customerDetails.cutOffAmount : 0).toFixed(2)}
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    ₹ {(parseFloat(customerDetails.netAmount) + parseFloat(
                                                    customerDetails.cutOffAmount && customerDetails.cutOffAmount != null ?
                                                        customerDetails.cutOffAmount : 0)).toFixed(2)}
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    ₹{" "}
                                                    {parseFloat(customerDetails.customDiscount).toFixed(
                                                        2
                                                    )}
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    ₹ {customerDetails.finalAmount}
                                                </p>
                                                <p style={{fontSize: "13px"}}>
                                                    ₹ {customerDetails.paidAmount}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    customerDetails && customerDetails.cancellationReason &&
                    <span style={{backgroundColor: '#e7baba', padding: '2px 4px'}}>
                                Cancellation Reason - {customerDetails && customerDetails.cancellationReason && customerDetails.cancellationReason}
                    </span>
                }
            </Modal>
        </>
    );
};

function Sale() {
    const checkUserType = getItemLocalstorage("user")["userType"];
    const userSaleCategory = getItemLocalstorage("user")["saleCategory"];

    let tableRef = useRef();
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState({
        visible: false,
        status: '',
        saleId: '',
        cancelledProducts: [],
    });
    const [isExportModalOpen, setIsExportModalOpen] = useState({
        visible: false,
    });
    const [shippingModal, setShippingModal] = useState(false);
    const [salesId, setSalesId] = useState(null);
    const [Report, setReport] = useState([]);
    const navigate = useNavigate();
    const [customerData, setCustomerData] = useState([]);
    const [searchSaleCategory, setSearchSalesCategory] = useState();
    const [searchbyPaymentStatus, setSearchByPaymentStatus] = useState("");
    const [searchType, setSearchType] = useState("");
    const [paymentRecord, setPaymentRecord] = useState([]);
    const [trackingDetails, setTrackingDetails] = useState("");
    const [shipThrough, setShipThrough] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [searchByOrderStatus, setSearchByOrderStatus] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [orderId, setOrderId] = useState("");
    const [searchByState, setSearchByState] = useState({
        stateCode: '',
        stateName: ''
    });
    const [saleCategory, setSaleCategory] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [paymentInState, setPaymentInState] = useState({
        visible: false, saleId: "", customer: {}
    })


    let [k, setk] = useState("");
    let [dates, setDates] = useState({
        fromDate: "",
        toDate: "",
    });

    let [productReportDates, setProductReportDates] = useState({
        fromDate: "",
        toDate: "",
    });

    const [customerDetails, setCustomerDetails] = useState({
        customerName: "",
        customerState: "",
        customerInvoice: "",
        customerNumber: "",
        purchaseDate: "",
        taxableAmount: "",
        sgstAmount: "",
        cgstAmount: "",
        igstAmount: "",
        gstAmount: "",
        totalAmount: "",
        paidAmount: "",
        netAmount: "",
        cutOffAmount: "",
        customDiscount: "",
        finalAmount: "",
        address: ""
    });
    const [count, setCount] = useState({
        total: 0,
        totalAmountSum: 0,
        totalDiscSum: 0,
        cutOffAmount: 0,
        taxableAmount: 0,
        gstAmount: 0,
        customDiscount: 0,
        paidAmount: 0,
        finalAmountSum: 0
    });
    const [showFilter, setShowFilter] = useState(false);
    const [cancelSaleModal, setCancelSaleModal] = useState({
        visible: false,
        saleId: '',
    });
    const [cancellationReason, setCancellationReason] = useState("");


    const fetchCategoryFrom = async () => {
        const {data} = await fetchSaleCategory({});
        setSaleCategory(data);
    };
    useEffect(() => {
        fetchCategoryFrom();
        // setSearchSalesCategory('Reception')
    }, []);

    useEffect(() => {
        if (userSaleCategory) {
            const matchedCategory = saleCategory.find(category => category._id == userSaleCategory);

            if (matchedCategory) {
                setSearchSalesCategory(matchedCategory.name);
            } else {
                setSearchSalesCategory('');
            }
        }
    }, [userSaleCategory, saleCategory]);

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (searchSaleCategory) {
                    params.saleCategoryName = searchSaleCategory;
                }
                if (searchbyPaymentStatus) {
                    params.paymentStatus = searchbyPaymentStatus;
                }

                if (userSaleCategory && !searchSaleCategory) {
                    params.saleCategory = userSaleCategory;
                }

                if (searchType && searchType !== "customer") {
                    params.type = searchType;
                }

                if (customerId) {
                    params.customerId = customerId;
                }
                if (searchByOrderStatus) {
                    params.orderStatus = searchByOrderStatus;
                }
                if (searchByState.stateName && searchByState.stateCode) {
                    params.stateOfSupply = searchByState.stateCode;
                }

                if (dates.fromDate && dates.toDate) {

                    params.salesDate = {
                        $gte: moment(dates.fromDate).startOf("day").toISOString(),
                        $lte: moment(dates.toDate).endOf("day").toISOString(),
                    };
                }
                const filters = ["saleCategoryName", "name", 'invoiceNumber', 'orderId'];

                if (!searchType || searchType !== "customer") {
                    filters.push("type");
                } else {
                    params.type = {$ne: "patient"};
                }
                if (invoiceNumber) {
                    params.invoiceNumber = invoiceNumber;
                }
                if (orderId) {
                    params.orderId = orderId;
                }

                const res = await fetchSale({
                    ...params,
                    regExFilters: filters,
                });
                const {data} = res;
                setCustomerData(data);
                const total = (res.total).toFixed(2) || count.total;
                const totalAmountSum = (res.totalAmountSum).toFixed(2) || count.totalAmountSum;
                const totalDiscSum = (res.totalDiscSum).toFixed(2) || count.totalDiscSum;
                const cutOffAmount = (res.cutOffAmount).toFixed(2) || count.cutOffAmount;
                const taxableAmount = (res.taxableAmount).toFixed(2) || count.taxableAmount;
                const gstAmount = (res.gstAmount).toFixed(2) || count.gstAmount;
                const customDiscount = (res.customDiscount).toFixed(2) || count.customDiscount;
                const finalAmountSum = (res.finalAmountSum).toFixed(2) || count.finalAmountSum;
                const paidAmount = (res.paidAmount).toFixed(2) || count.paidAmount;
                setCount({
                    total: total,
                    totalAmountSum: totalAmountSum,
                    totalDiscSum: totalDiscSum,
                    cutOffAmount: cutOffAmount,
                    taxableAmount: taxableAmount,
                    gstAmount: gstAmount,
                    customDiscount: customDiscount,
                    finalAmountSum: finalAmountSum,
                    paidAmount: paidAmount,
                })
                resolve(res);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const fetchcustomerdata = () => {
        const allrecordofcustomer = customerData.filter(
            (item) => item._id == salesId
        );
        allrecordofcustomer.map((i) => {
            setCustomerDetails({
                customerName: i.customerId?.name,
                customerState: i.customerId?.state,
                customerNumber: i.customerId?.mobile,
                address: i.customerId?.address,
                city: i.customerId?.city,
                state: i.customerId?.state,
                country: i.customerId?.country,
                customerInvoice: i.invoiceNumber,
                salesDate: i.salesDate,
                trackingDetails: i.trackingDetails,
                shipThrough: i.shipThrough,
                taxableAmount: i.taxableAmount,
                cgstAmount: i.cgstAmount,
                sgstAmount: i.sgstAmount,
                igstAmount: i.igstAmount,
                netAmount: i.netAmount,
                totalAmount: i.totalAmount,
                gstAmount: i.gstAmount,
                paidAmount: i.paidAmount,
                customDiscount: i.customDiscount,
                cutOffAmount: i.cutOffAmount,
                finalAmount: i.finalAmount,
                cancellationReason: i.cancellationReason,
            });
            setPaymentRecord(i.paidToUser);
            return;
        });
    };

    const fetchProductReport = async () => {
        try {
            let config = {
                params: {salesId},
                ...(await getToken()),
            };

            dispatch(showLoader());
            const response = await axios.get(getProductReport(), config);
            setReport(response.data.data);
            dispatch(hideLoader());
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };

    const statusChangeFunction = async (
        _id,
        trackingDetails,
        shipThrough,
        status
    ) => {
        try {
            let config = {
                params: {_id: _id},
                ...(await getToken()),
            };

            if (trackingDetails) {
                config.params.trackingDetails = trackingDetails;
            }
            if (shipThrough) {
                config.params.shipThrough = shipThrough;
            }
            if (status) {
                config.params.orderStatus = status;
            }
            dispatch(showLoader());
            const response = await axios.get(statusChangeUrl(), config);
            if (response) {
                dispatch(hideLoader());
            }
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };
    const paymentStatusUpdate = async (_id, paymentStatus) => {
        try {
            let config = {
                params: {_id: _id},
                ...(await getToken()),
            };
            if (paymentStatus) {
                config.params.paymentStatus = paymentStatus;
            }
            dispatch(showLoader());
            const response = await axios.get(statusChangeUrl(), config);
            dispatch(hideLoader());
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };
    const cancelSale = async (saleId) => {
        try {
            let config = {
                ...(await getToken()),
            };
            if (!cancellationReason) {
                notification.warning({message: 'Please Enter Reason'})
                return
            }
            const data = {
                saleId: saleId,
                cancellationReason: cancellationReason
            }
            const response = await axios.post(cancelSaleUrl(), data, config);
            if (response) {
                tableRef.current.reload();
                notification.success({message: response.data.message});
                setCancelSaleModal({visible: false, saleId: ''})
                setCancellationReason('')
                setk(new Date().toString());
                return;
            } else {
                notification.error({message: response.data.message});
            }
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };

    useEffect(() => {
        apiRequest();
    }, []);

    useEffect(() => {
        if (salesId) {
            fetchProductReport();
            fetchcustomerdata();
        }
    }, [salesId]);

    const handleFilter = async () => {
        setShowFilter(!showFilter);
    };
    const clearSaleFilters = () => {
        setSearchByPaymentStatus('');
        setSearchType('');
        setCustomerId('');
        setSearchByOrderStatus('');
        setSearchSalesCategory('');
        setSearchByState({
            stateName: '',
            stateCode: ''
        });
        setDates({
            fromDate: '',
            toDate: ''
        });
        setShowFilter(!showFilter);
        setInvoiceNumber('');
        setOrderId('');
        tableRef.current.reload()
    };

    const events = {
        getState: () => {
            let resp = getStateByCountry('India');
            setStateList(resp);
        },
        showPaymentIn: (sale) => {
            setPaymentInState({
                visible: true, saleId: sale._id, customer: sale.customerId
            })
        },
        hidePaymentIn: () => {
            setPaymentInState({
                visible: false, saleId: "", customer: {}
            })
        },
    };
    useEffect(() => {
        events.getState();
    }, []);


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
            width: 60,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            width: 120,
            render: (text, record) => <span>{text?.name}</span>,
        },
        {
            title: "Mobile",
            dataIndex: "customerId",
            key: "customerId",
            width: 100,
            render: (text) => <span>{text?.mobile}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
            width: 80,
        },
        {
            title: "Sale Category",
            dataIndex: "saleCategoryName",
            key: "orderId",
            width: 100,
        },
        {
            title: "Order Id",
            dataIndex: "orderId",
            key: "saleCategoryName",
            width: 80,
        },
        {
            title: "Sales Date",
            dataIndex: "salesDate",
            key: "salesDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YY, hh:mm A")}</span>,
            width: 125,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
            width: 140,
        },
        {
            title: "Total Qty",
            dataIndex: "quantity",
            key: "quantity",
            width: 46,
        },
        {
            title: "Net Amount",
            dataIndex: "finalAmount",
            key: "finalAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },
        // {
        //   title: "Cutoff Amount",
        //   dataIndex: "cutOffAmount",
        //   key: "cutOffAmount",
        //   render: (text) => <span>Rs. {text}</span>,
        // },
        // {
        //   title: "Custom Discount",
        //   dataIndex: "customDiscount",
        //   key: "customDiscount",
        //   render: (text) => <span>Rs. {text}</span>,
        // },
        // {
        //   title: "Final Amount",
        //   dataIndex: "finalAmount",
        //   key: "finalAmount",
        //   render: (text) => <span>Rs. {text}</span>,
        // },
        {
            title: "Received Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },
        // {
        //   title: "Balance",
        //   dataIndex: "balance",
        //   key: "balance",
        //   render: (text) => <span>Rs. {text}</span>,
        // },
        // {
        //     title: "Order Id",
        //     dataIndex: "orderId",
        //     width: 100,
        //     key: "orderId",
        // },
        {
            title: "Order Status",
            dataIndex: "orderStatus",
            width: 80,
            key: "orderStatus",
        },
        {
            title: "Tracking Id",
            dataIndex: "trackingDetails",
            width: 80,
            key: "trackingDetails",
        },
        {
            title: "Payment Status",
            dataIndex: "paymentStatus",
            width: 80,
            key: "paymentStatus",
        },
        {
            title: "Actions",
            dataIndex: "description",
            key: "description",
            width: 200,
            fixed: "right",
            render: (text, record) => (
                <>
                    <Tooltip title={"View"}>
                        <a
                            className={"empty_btn sizeIcon"}
                            onClick={() => {
                                setIsModalOpen({
                                    visible: true,
                                    saleId: record._id,
                                    status: record.orderStatus,
                                    cancelledProducts: record.deletedProductReports
                                });
                                setSalesId(record._id);
                            }}
                        >
                            <i className={"fa fa-eye far"}/>
                        </a>
                    </Tooltip>
                    <Tooltip title={"Print"}>
                        <a
                            href={`/print-sale?_id=${record._id}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={"./printer-50.png"} className="print" alt={""}/>
                        </a>
                    </Tooltip>
                    {record.orderStatus === "Processed" &&
                    record.customerId?.type !== "patient" ? (
                        <Tooltip title={"Ship?"}>
                            <a
                                className={"empty_btn sizeIcon"}
                                onClick={() => {
                                    setShippingModal(true);
                                    setSalesId(record._id);
                                }}
                            >
                                <i className={"fa fa-truck far"}/>
                            </a>
                        </Tooltip>
                    ) : null}
                    {record.orderStatus === "Shipped" && record.type !== "patient" ? (
                        <Tooltip title={"Deliver?"}>
                            <Popconfirm
                                title={
                                    "Are your sure, you want to change the order status to Delivered?"
                                }
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    const status = "Delivered";
                                    statusChangeFunction(
                                        record._id,
                                        trackingDetails,
                                        shipThrough,
                                        status
                                    );
                                    setk(new Date().toString());
                                }}
                            >
                                <a className={"empty_btn sizeIcon"}>
                                    <i className={"fas fa-archive far"}></i>
                                </a>
                            </Popconfirm>
                        </Tooltip>
                    ) : null}
                    {record.paymentStatus == "Pending" && (
                        <>
                            <a className={"empty_btn sizeIcon"} onClick={() => {
                                events.showPaymentIn(record)
                            }}>
                                <i className={"fas fa-rupee-sign"}/>
                            </a>
                            {/*<Tooltip title={"Payment Done?"}>
                                <Popconfirm
                                    title={"Are your sure, you want to done payment status?"}
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => {
                                        const paymentStatus = "Done";
                                        events.showPaymentIn(record)

                                        // paymentStatusUpdate(record._id, paymentStatus);
                                        // setk(new Date().toString());
                                    }}>
                                    <a className={"empty_btn sizeIcon"}>
                                        <i className={"fas fa-rupee-sign"}/>
                                    </a>
                                </Popconfirm>
                            </Tooltip>*/}
                        </>
                    )}
                    {/*record.type != 'patient'*/}
                    {record.orderStatus !== "Canceled" && (
                        <Tooltip title={"Cancel Sale"}>
                            {/*<Popconfirm
                                title={"Are your sure, you want to cancel Sale?"}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    const status = "Canceled";
                                    statusChangeFunction(
                                        record._id,
                                        trackingDetails,
                                        shipThrough,
                                        status
                                    );
                                    cancelSale(record._id)
                                    setk(new Date().toString());
                                }}
                            >
                            </Popconfirm>*/}
                            <a className={"empty_btn sizeIcon"} onClick={
                                () => {
                                    setCancelSaleModal({visible: true, saleId: record._id})
                                }
                            }>
                                <i className={"fas fa-times far"}/>
                            </a>
                        </Tooltip>
                    )}
                    {record.status !== "Done" &&
                        record?.type != "royalty" &&
                        record?.type != "patient" &&
                        record.orderStatus != "Canceled" && (
                            <Tooltip title={"Edit"}>
                                <a className={"empty_btn sizeIcon"}
                                   onClick={() => {
                                       navigate(`/edit-sale?_id=${record._id}`);
                                   }}
                                >
                                    <i className={'fas fa-pencil far'}/>
                                    {/*<img className={'print'} src={"./edit.svg"}/>*/}
                                </a>
                            </Tooltip>
                        )}
                    {record.status !== "Done" && record?.type == "patient" ?
                        <Tooltip title={"Edit"}>
                            <a className={"empty_btn sizeIcon"}
                               onClick={() => {
                                   navigate(`/edit-patient-sale?_id=${record._id}`);
                               }}
                            >
                                <i className={'fas fa-pencil far'}/>

                            </a>
                        </Tooltip> : null}
                </>
            ),
        },
    ];

    const printFxn = () => {
        const printContents = document.getElementById("printable").innerHTML;
        const originalContents = document.body.innerHTML;
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = printContents;
        const styleElement = document.createElement("style");
        styleElement.innerHTML = `
    table {
        width: 100%;
        border-collapse: collapse;
        margin-left:10px;
        table-layout: unset !important;
    }
    th, td {
        word-break: break-word;
        white-space: normal;
        padding: 8px;
        border: 1px solid #ddd;
    }
    th {
        background-color: #f2f2f2;
    }
`;
        tempDiv.appendChild(styleElement);

        const table = tempDiv.querySelector("table");
        if (table) {
            const headers = table.querySelectorAll("th");
            let actionsIndex = -1;
            headers.forEach((header, index) => {
                if (header.innerText.trim() === "Actions") {
                    actionsIndex = index;
                }
            });
            if (actionsIndex !== -1) {
                headers[actionsIndex].remove();
                const rows = table.querySelectorAll("tr");
                rows.forEach(row => {
                    const cells = row.querySelectorAll("td, th");
                    if (cells.length > actionsIndex) {
                        cells[actionsIndex].remove();
                    }
                });
            }
        }
        document.body.innerHTML = tempDiv.innerHTML;
        window.print();
        document.body.innerHTML = originalContents;
        // window.location.reload();
    };

    const handleConvertToCsv = async () => {
        try {
            if (!dates.fromDate) {
                notification.error({message: 'Enter the starting date!'});
                return;
            }
            let toDate = dates.toDate ? dates.toDate : moment();
            const params = {
                salesDate: {
                    $gte: moment(dates.fromDate).startOf("day").toISOString(),
                    $lte: moment(toDate).endOf("day").toISOString(),
                }
            };
            if (searchSaleCategory) {
                params.saleCategoryName = searchSaleCategory;
            }
            if (searchbyPaymentStatus) {
                params.paymentStatus = searchbyPaymentStatus;
            }

            if (userSaleCategory && !searchSaleCategory) {
                params.saleCategory = userSaleCategory;
            }

            if (searchType && searchType !== "customer") {
                params.type = searchType;
            }

            if (customerId) {
                params.customerId = customerId;
            }
            if (searchByOrderStatus) {
                params.orderStatus = searchByOrderStatus;
            }
            if (searchByState.stateName && searchByState.stateCode) {
                params.stateOfSupply = searchByState.stateCode;
            }
            const filters = ["saleCategoryName", "name"];

            if (!searchType || searchType !== "customer") {
                filters.push("type");
            } else {
                params.type = {$ne: "patient"};
            }
            const csvBlob = await fetchSaleForCsv({
                ...params,
                regExFilters: filters,
            });
            if (csvBlob instanceof Blob) {
                const url = window.URL.createObjectURL(csvBlob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'sales_data.xlsx'); // Adjust file extension if needed
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                throw new Error('The fetched data is not a valid Blob');
            }
        } catch (error) {
            console.error('Error handling CSV conversion:', error);
            notification.error({message: 'Error converting data to CSV!'});
        }
    };
    const handleConvertToCsvProducts = async () => {
        try {
            if (!productReportDates.fromDate) {
                notification.warning({message: 'Enter from date!'});
                return;
            }
            let toDate = productReportDates.toDate ? productReportDates.toDate : moment();
            const params = {
                salesDate: {
                    $gte: moment(productReportDates.fromDate).startOf("day").toISOString(),
                    $lte: moment(toDate).endOf("day").toISOString(),
                }
            };

            const csvBlob = await dispatch(fetchSaleProductsForCsv({
                ...params,
            }));
            if (csvBlob instanceof Blob) {
                const url = window.URL.createObjectURL(csvBlob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'sales_data.xlsx'); // Adjust file extension if needed
                document.body.appendChild(link);
                link.click();
                link.remove();
                setIsExportModalOpen({visible: false})
                setProductReportDates({
                    fromDate: "",
                    toDate: "",
                })
            } else {
                throw new Error('The fetched data is not a valid Blob');
            }
        } catch (error) {
            console.error('Error handling CSV conversion:', error);
            notification.error({message: 'Error converting data to CSV!'});
        }
    };

    return (
        <PageHeader
            header={'Sales'}
            title={<div style={{display: 'flex', alignItems: 'center'}}>
                <div>Sales({Number(count.total)})</div>
            </div>}

            extraLink={[
                {
                    name: "Add Sale",
                    link: "/add-sales",
                },
            ]}
        >
            <div className="card">
                <div className="card-body">
                    <div className=" row">
                        <div className={"col-md-2 pe-0"}>
                            <SearchCustomer
                                type={["customer", "patient", "branch"]}
                                customerId={customerId}
                                callback={(clientData) => {
                                    if (clientData && clientData._id) {
                                        setCustomerId(clientData._id);
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-2 mb-2 pe-0">
                            {/*<label htmlFor="searchCategory" className="form-label"/>*/}
                            <select
                                className="form-control "
                                placeholder="Search by Type"
                                onChange={(e) => setSearchType(e.target.value)}>
                                <option value="">Select Type</option>
                                <option value="patient">Service</option>
                                <option value="customer">Medicines</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            {/*<label htmlFor="searchCategory" className="form-label"/>*/}
                            <input
                                className="form-control"
                                name="name"
                                value={invoiceNumber}
                                placeholder="Search by Invoice Number"
                                onChange={(e) => {
                                    setInvoiceNumber(e.target.value)
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            {/*<label htmlFor="searchCategory" className="form-label"/>*/}
                            <input
                                className="form-control"
                                name="name"
                                value={orderId}
                                placeholder="Search by Order Id "
                                onChange={(e) => {
                                    setOrderId(e.target.value)
                                }}
                            />
                        </div>

                        <div className="col-md-2 pe-0">
                            {/*<label htmlFor="searchCategory" className="form-label"/>*/}
                            <SelectRc
                                className="form-control "
                                item={{label: 'Sale Category'}}
                                id="searchCategory"
                                onSearch={[]}
                                keyAccessor={(val) => val.name}
                                valueAccessor={(val) => val.name}
                                onChange={(e) => {
                                    setSearchSalesCategory(e)
                                }}
                                value={searchSaleCategory}
                                options={saleCategory}
                            >
                            </SelectRc>
                        </div>
                        <div className="col-md-2 ">
                            <select
                                className="form-control "
                                id="searchCategory"
                                placeholder="Search by Type"
                                onChange={(e) => setSearchByPaymentStatus(e.target.value)}
                            >
                                <option value="">Select Payment Status</option>
                                <option value="Pending">Pending</option>
                                <option value="Done">Done</option>
                            </select>
                        </div>
                        <div className="col-md-2 ">
                            <select
                                className="form-control "
                                id="searchCategory"
                                placeholder="Search by Type"
                                onChange={(e) => setSearchByOrderStatus(e.target.value)}
                            >
                                <option value="">Select Order Status</option>
                                <option value="Canceled">Canceled</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Delivered">Delivered</option>
                                {/*<option value="Processed">Processed</option>*/}
                            </select>
                        </div>
                        <div className="col-md-2 ">
                            <select
                                placeholder="Search by State"
                                className="form-control"
                                value={searchByState.stateName} // Assuming searchByState is your state object
                                onChange={(e) => {
                                    const selectedState = stateList.find(state => state.name === e.target.value);
                                    setSearchByState({
                                        ...searchByState,
                                        stateName: selectedState ? selectedState.name : '',
                                        stateCode: selectedState ? selectedState.stateCode : ''
                                    });
                                }}
                                required
                            >
                                <option value="">Select State</option>
                                {stateList.map((state) => (
                                    <option key={state.name} value={state.name}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="col-md-2">
                            {/*<label htmlFor="searchCategory" className="form-label"/>*/}
                            <DatePicker
                                type="date"
                                className="form-control "
                                name="name"
                                value={dates.fromDate}
                                onChange={(e) =>
                                    setDates({...dates, fromDate: e})
                                }
                            />
                        </div>
                        <div className="col-md-2">
                            <DatePicker
                                type="date"
                                className="form-control "
                                name="name"
                                value={dates.toDate}
                                onChange={(e) => setDates({...dates, toDate: e})}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 search-buttons mb-2 mt-3">
                        <div className="search-wrap">
                            <button className="btn btn-info" onClick={handleFilter}>
                                Search
                            </button>
                        </div>
                        <div className="search-wrap">
                            <button className="btn btn-secondary" onClick={clearSaleFilters}>
                                Clear
                            </button>
                        </div>
                        <div className="search-wrap">
                            <button className="btn btn-success" onClick={printFxn}>
                                Print
                            </button>
                        </div>
                        <div className="search-wrap">
                            <Popconfirm
                                title="Are you sure you want to export the data?"
                                onConfirm={handleConvertToCsv}
                                okText="Yes"
                                cancelText="No"
                            >
                                <button className="btn btn-dark">
                                    Export
                                </button>
                            </Popconfirm>
                        </div>
                        <div className="search-wrap">

                            <button className="btn btn-dark  "

                                    onClick={() => {
                                        setIsExportModalOpen({
                                            visible: true
                                        })
                                    }}>
                                Export Product Wise Report
                            </button>
                        </div>
                    </div>
                    <div className={"saleTable"} id="printable">
                        <div style={{display: 'flex', alignItems: 'end'}}>
                            <div style={{fontSize: "smaller", marginTop: "5px"}}>
                                <b>Count:</b> {count.total} &nbsp;&nbsp;&nbsp;
                                <b>Total Amount:</b> ₹ {count.totalAmountSum} &nbsp;&nbsp;&nbsp;
                                <b>Total Cash Disc:</b> ₹ {count.totalDiscSum} &nbsp;&nbsp;&nbsp;
                                <b>Total RoundOff:</b> ₹ {count.cutOffAmount} &nbsp;&nbsp;&nbsp;
                                <b>Final Amount:</b> ₹ {parseFloat(count.finalAmountSum).toFixed(2)} &nbsp;&nbsp;&nbsp;
                                <b>Paid Amount:</b> ₹ {count.paidAmount}
                            </div>
                        </div>
                        {showFilter ? <Table
                            apiRequest={apiRequest}
                            columns={columns}
                            ref={tableRef}

                            key={k}
                            position={"top"}
                            pagination={{...DefaultTablePagination(), defaultPageSize: 50}}
                            extraProps={{scroll: {x: 100},}}
                        /> : <div>
                            <Table
                                apiRequest={apiRequest}
                                columns={columns}
                                ref={tableRef}

                                key={k}
                                position={"top"}
                                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}
                                extraProps={{scroll: {x: 100},}}
                            />
                        </div>}
                    </div>
                </div>
            </div>
            {isModalOpen.visible ? (
                <>
                    <ProductReportList
                        visible={isModalOpen.visible}
                        Report={isModalOpen.status == 'Canceled' ? isModalOpen.cancelledProducts : Report}
                        onClose={() => {
                            setIsModalOpen({
                                visible: false,
                                saleId: '',
                                cancelledProducts: '',
                                status: ''
                            });
                            setReport([]);
                            setSalesId("");
                        }}
                        paymentRecord={paymentRecord}
                        customerDetails={customerDetails}
                        status={isModalOpen.status}
                    />
                </>
            ) : null}

            <Modal
                title={"Shipping"}
                width={"40%"}
                visible={shippingModal}
                onClose={() => {
                    setShippingModal(false);
                }}
            >
                <div>
                    <InputBox>
            <textarea
                className={"form-control"}
                type="text"
                value={trackingDetails}
                placeholder="Tracking Details..."
                onChange={(e) => setTrackingDetails(e.target.value)}
            />
                    </InputBox>
                    <InputBox className="mb-3 mt-3">
                        <select
                            className="form-control"
                            value={shipThrough}
                            onChange={(e) => setShipThrough(e.target.value)}
                            required="true"
                        >
                            <option value="">Select Ship Through</option>
                            {shipthrough?.map((ship) => (
                                <option key={ship.name} value={ship.name}>
                                    {ship.name}
                                </option>
                            ))}
                        </select>
                    </InputBox>
                    <div className="text-end">
                        <button
                            className="btn btn-info"
                            onClick={() => {
                                setShippingModal(false);
                                let status = "Shipped";
                                statusChangeFunction(
                                    salesId,
                                    trackingDetails,
                                    shipThrough,
                                    status
                                );
                                setTrackingDetails("");
                                setk(new Date().toString());
                            }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal
                title={"Cancel Sale"}
                width={"40%"}
                visible={cancelSaleModal.visible}
                onClose={() => {
                    setCancelSaleModal({...cancelSaleModal, visible: false});
                }}
            >
                <div>
                    <InputBox>
            <textarea
                className={"form-control"}
                type="text"
                value={cancellationReason}
                placeholder="Enter Reason..."
                onChange={(e) => setCancellationReason(e.target.value)}
            />
                    </InputBox>
                    <div className="text-end mt-2">
                        <button
                            className="btn btn-info"
                            onClick={() => {
                                const status = "Canceled";
                                statusChangeFunction(
                                    cancelSaleModal.saleId,
                                    trackingDetails,
                                    shipThrough,
                                    status
                                );
                                cancelSale(cancelSaleModal.saleId)
                            }}>
                            Cancel Sale
                        </button>
                    </div>
                </div>
            </Modal>
            {
                isExportModalOpen.visible &&
                <Modal
                    title={"Export Product Wise"}
                    width={"45%"}
                    visible={isExportModalOpen.visible}
                    onClose={() => {
                        setIsExportModalOpen({visible: false});
                    }}
                >
                    <div className="container">
                        <div className="row g-3 align-items-end">
                            <div className="col-md-5">
                                <InputBox title="From Date">
                                    <DatePicker
                                        className="form-control"
                                        value={productReportDates.fromDate}
                                        onChange={(e) =>
                                            setProductReportDates({...productReportDates, fromDate: e})
                                        }
                                    />
                                </InputBox>
                            </div>
                            <div className="col-md-5">
                                <InputBox title="To Date">
                                    <DatePicker
                                        className="form-control"
                                        value={productReportDates.toDate}
                                        onChange={(e) =>
                                            setProductReportDates({...productReportDates, toDate: e})
                                        }
                                    />
                                </InputBox>
                            </div>
                            <div className="col-md-2 text-md-end">
                                <button
                                    className="btn btn-gradient-success w-100"
                                    onClick={handleConvertToCsvProducts}
                                >
                                    Export
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {paymentInState.visible ?
                <PaymentInDrawer
                    {...paymentInState}
                    onClose={events.hidePaymentIn}
                    onSubmit={() => {
                        tableRef.current.reload();
                        setk(new Date().toString());
                        events.hidePaymentIn()
                    }}
                /> : null
            }
        </PageHeader>
    );
}

export default Sale;
